<template>
  <div>
    <div class="hero">
      <div class="container d-flex">
        <div>
          <h4 class="">Hey, my name is</h4>
          <h1 class="text fw-heavy">Connor &#128075;</h1>
          <h1 class="text fw-heavy" style="margin-bottom: 30px; color: #fd2755">
            I build things that work.
          </h1>
          <h4 class="fw-light">
            I'm currently working as a developer at
            <span class="fw-heavy">
              <span class="company pass">
                <a
                  class="shadow-underline"
                  href="https://www.technologyone.com.au"
                  target="_blank"
                >
                  TechnologyOne
                </a></span
              >
            </span>
            building a new search engine using ElasticSearch, C# and Docker.
          </h4>
        </div>
      </div>
    </div>
    <div>
      <div class="container">
        <div class="section-header">
          <h1 class="text-light fw-heavy">Skills</h1>
          <h1 class="text-light fw-light">Core Competencies</h1>
        </div>
        <div class="grid-icons">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            width="59px"
            height="65px"
            viewBox="0 0 222 249"
            v-tippy="{
              content: 'C# / .Net',
              animation: 'scale',
            }"
          >
            <rect
              v-tippy="{
                content: '',
                animation: 'scale',
              }"
            />
            <g id="surface1">
              <path
                style="
                  stroke: none;
                  fill-rule: nonzero;
                  fill: rgb(63.137255%, 47.45098%, 86.27451%);
                  fill-opacity: 1;
                "
                d="M 221.011719 73.710938 C 221.011719 69.566406 220.121094 65.902344 218.324219 62.757812 C 216.558594 59.667969 213.910156 57.074219 210.363281 55.027344 C 181.066406 38.1875 151.746094 21.398438 122.460938 4.542969 C 114.5625 0 106.910156 0.167969 99.074219 4.777344 C 87.414062 11.628906 29.035156 44.972656 11.636719 55.015625 C 4.472656 59.152344 0.988281 65.480469 0.988281 73.703125 C 0.976562 107.566406 0.988281 141.433594 0.976562 175.296875 C 0.976562 179.351562 1.828125 182.945312 3.546875 186.039062 C 5.316406 189.222656 8 191.886719 11.628906 193.980469 C 29.027344 204.027344 87.410156 237.367188 99.070312 244.222656 C 106.910156 248.835938 114.5625 249 122.460938 244.457031 C 151.75 227.597656 181.074219 210.8125 210.371094 193.972656 C 214.003906 191.878906 216.683594 189.214844 218.453125 186.03125 C 220.167969 182.933594 221.023438 179.34375 221.023438 175.285156 C 221.023438 175.285156 221.023438 107.574219 221.011719 73.710938 "
              />
              <path
                style="
                  stroke: none;
                  fill-rule: nonzero;
                  fill: rgb(15.686275%, 0%, 40.784314%);
                  fill-opacity: 1;
                "
                d="M 111.335938 124.167969 L 3.546875 186.039062 C 5.316406 189.222656 8 191.886719 11.628906 193.980469 C 29.027344 204.027344 87.410156 237.367188 99.070312 244.222656 C 106.910156 248.835938 114.5625 249 122.460938 244.457031 C 151.75 227.597656 181.074219 210.8125 210.371094 193.972656 C 214.003906 191.878906 216.683594 189.214844 218.453125 186.03125 Z M 111.335938 124.167969 "
              />
              <path
                style="
                  stroke: none;
                  fill-rule: nonzero;
                  fill: rgb(22.352941%, 0%, 56.862745%);
                  fill-opacity: 1;
                "
                d="M 221.011719 73.710938 C 221.011719 69.566406 220.121094 65.902344 218.324219 62.757812 L 111.335938 124.171875 L 218.453125 186.03125 C 220.167969 182.933594 221.023438 179.34375 221.023438 175.285156 C 221.023438 175.285156 221.023438 107.574219 221.011719 73.710938 "
              />
              <path
                style="
                  stroke: none;
                  fill-rule: nonzero;
                  fill: rgb(100%, 100%, 100%);
                  fill-opacity: 1;
                "
                d="M 174.800781 101.039062 L 174.800781 112.605469 L 186.398438 112.605469 L 186.398438 101.039062 L 192.199219 101.039062 L 192.199219 112.605469 L 203.800781 112.605469 L 203.800781 118.386719 L 192.199219 118.386719 L 192.199219 129.953125 L 203.800781 129.953125 L 203.800781 135.734375 L 192.199219 135.734375 L 192.199219 147.300781 L 186.398438 147.300781 L 186.398438 135.734375 L 174.800781 135.734375 L 174.800781 147.300781 L 169 147.300781 L 169 135.734375 L 157.398438 135.734375 L 157.398438 129.953125 L 169 129.953125 L 169 118.386719 L 157.398438 118.386719 L 157.398438 112.605469 L 169 112.605469 L 169 101.039062 Z M 186.398438 118.386719 L 174.800781 118.386719 L 174.800781 129.953125 L 186.398438 129.953125 Z M 186.398438 118.386719 "
              />
              <path
                style="
                  stroke: none;
                  fill-rule: nonzero;
                  fill: rgb(100%, 100%, 100%);
                  fill-opacity: 1;
                "
                d="M 111.574219 42.960938 C 141.832031 42.960938 168.25 59.34375 182.398438 83.691406 L 182.261719 83.457031 L 146.660156 103.894531 C 139.644531 92.054688 126.789062 84.066406 112.039062 83.898438 L 111.574219 83.898438 C 89.078125 83.898438 70.84375 102.074219 70.84375 124.5 C 70.835938 131.566406 72.6875 138.511719 76.214844 144.644531 C 83.234375 156.863281 96.433594 165.101562 111.574219 165.101562 C 126.804688 165.101562 140.078125 156.757812 147.0625 144.410156 L 146.894531 144.703125 L 182.441406 165.234375 C 168.445312 189.378906 142.390625 205.707031 112.484375 206.035156 L 111.574219 206.039062 C 81.21875 206.039062 54.726562 189.554688 40.613281 165.078125 C 33.722656 153.125 29.78125 139.273438 29.78125 124.5 C 29.78125 79.46875 66.398438 42.960938 111.574219 42.960938 Z M 111.574219 42.960938 "
              />
            </g>
          </svg>
          <font-awesome-icon
            v-for="icon in technologies"
            :key="icon"
            class="icon-lg ms-1"
            :icon="[icon.prefix, icon.suffix]"
            :style="{ color: icon.color }"
            v-tippy="{ content: icon.name, animation: 'scale' }"
          />
          <inline-svg
            :src="elastic"
            fill="white"
            v-tippy="{ content: 'Elasticsearch', animation: 'scale' }"
          />
        </div>
      </div>
    </div>

    <div ref="work">
      <div class="container">
        <div class="section-header">
          <h1 class="fw-heavy">Work</h1>
          <h1 class="fw-light">Featured Projects</h1>
        </div>

        <div class="grid">
          <project
            class=""
            v-for="project in projects"
            :key="project"
            :img="project.img"
            :imgBackground="project.imgBackgroundColor"
            :type="project.type"
            :description="project.description"
            :title="project.title"
            :technologies="project.technologies"
            :links="project.links"
          />
        </div>
        <!-- <div class="text-center section-footer">
          <a href="#" class="shadow-underline fs-5 fw-light">View More</a>
        </div> -->
      </div>
    </div>

    <div class="bg-in" ref="experience">
      <div class="container">
        <div class="section-header">
          <h1 class="fw-heavy">Experience</h1>
          <h1 class="fw-light">Where I've Worked</h1>
        </div>
        <tabs>
          <tab
            v-for="company in companies"
            :key="company"
            :title="company.name"
          >
            <div class="tab-header">
              <div class="d-flex">
                <h4 class="fw-heavy">
                  <span> {{ company.jobTitle }}</span>
                  <span class="company pass">
                    @
                    <a
                      class="shadow-underline"
                      :href="company.link"
                      target="_blank"
                    >
                      {{ company.name }}
                    </a></span
                  >
                </h4>
              </div>
              <h4 class="fw-light">{{ company.employmentTime }}</h4>
            </div>
            <ul>
              <li v-for="experience in company.experience" :key="experience">
                {{ experience }}
              </li>
            </ul>
          </tab>
        </tabs>
      </div>
    </div>
  </div>
</template>

<script>
import project from "@/components/Project";
import tab from "@/components/Tab";
import tabs from "@/components/Tabs";
import "tippy.js/animations/scale.css";

export default {
  name: "Home",
  components: { project, tab, tabs },
  data: function () {
    return {
      elastic: require("../images/elastic.svg"),
      projects: [
        {
          img: require("../images/qps-logo.png"),
          imgBackgroundColor: "#212129",
          type: "Client",
          title: "Queensland Police Fraud Detection",
          technologies: ["React", "Node.js", "Python", "Azure"],
          description:
            "A production ready fraud detection platform created for the Queensland Police deployed to Azure which uses machine learning and Google's Safe Browsing API to identify malicious attackers.",
          links: [
            {
              icon: "external-link-square",
              style: "far",
              link: "https://www.youtube.com/watch?v=p16x89jiKbo&ab_channel=ConnorBrodie",
            },
          ],
        },
        {
          img: require("../images/sentiment.png"),
          imgBackgroundColor: "#212129",
          type: "University",
          title: "CryptoCrowd",
          technologies: ["Node.js", "Express", "React", "AWS"],
          description:
            "Cryptocurrency sentiment analysis on Twitter posts. This is a Stateless application that uses Elasticache, S3, EC2 and auto-scaling to manage demand. Built using React and Node.js.",
          links: [
            {
              icon: "github-square",
              style: "fab",
              link: "https://github.com/conbrodie/crypto-crowd",
            },
          ],
        },
        {
          img: require("../images/api.png"),
          imgBackgroundColor: "#212129",
          type: "Personal",
          title: "Kanban API",
          technologies: ["C#", "Docker", "SQL"],
          description:
            "An API designed to simulate a simple kanban board. Built using C#, .Net Framework, SQL Server and Swagger for API documentation.",
          links: [
            {
              icon: "github-square",
              style: "fab",
              link: "https://github.com/conbrodie/kanban_api",
            },
            // {
            //   icon: "external-link-square",
            //   style: "far",
            //   link: "http://kanban-env.eba-qskzrymi.ap-southeast-2.elasticbeanstalk.com/index.html",
            // },
          ],
        },
        {
          img: require("../images/powertorq.png"),
          imgBackgroundColor: "#212129",
          type: "Client",
          title: "PowerTorq",
          technologies: ["Vue", "Docker", "C#", "Linux"],
          description:
            "A website created to improve PowerTorq's reach and sales. Built using Vue.js, C#, Docker & Docker Compose and deployed to Digital Ocean on Ubuntu.",
          links: [
            {
              icon: "external-link-square",
              style: "far",
              link: "https://www.powertorq.com.au",
            },
          ],
        },
        {
          img: require("../images/rubiks.png"),
          imgBackgroundColor: "#212129",
          type: "University",
          title: "2x2x2 Rubiks Solver",
          technologies: ["Python"],
          description:
            "A program that uses breadth-first search to calculate the shortest path from a scrambled rubiks cube configuation to a solved configuration.",
          links: [
            {
              icon: "github-square",
              style: "fab",
              link: "https://github.com/conbrodie/rubik-solver",
            },
          ],
        },
        {
          img: require("../images/AssetTrading.jpg"),
          imgBackgroundColor: "#212129",
          type: "University",
          title: "Asset Trading Platform",
          technologies: ["Java", "MariaDB"],
          description:
            "A client-server system in Java for trading of virtual assets within company departments. Utilised SDLC by covering requirements, database design, class diagram, network protocol design and GUI wireframes.",
          links: [
            {
              icon: "github-square",
              style: "fab",
              link: "https://github.com/conbrodie/AssetTradingPlatfom",
            },
          ],
        },
      ],
      technologies: [
        { prefix: "fab", suffix: "react", color: "#14daff", name: "React" },
        { prefix: "fab", suffix: "docker", color: "#1e63ed", name: "Docker" },
        {
          prefix: "fab",
          suffix: "github-square",
          color: "#c3c3c4",
          name: "Github",
        },
        { prefix: "fab", suffix: "node", color: "#08ad7e", name: "Node.js" },
      ],
      companies: [
        {
          name: "TechnologyOne",
          jobTitle: "Software Developer",
          employmentTime: "July 2022 to Present",
          experience: [
            "Enterprise level implementation of containerised OpenSearch (ElasticSearch) platform for document and generic business entity search (Docker, OpenSearch, C# ASP.NET, PostgreSQL, Tesseract OCR, AWS)",
            "Enterprise level implementation of Sharepoint automatic document ingestion (C# ASP.NET, Aspose, HTML/CSS, Typescript, Microsoft Graph API)",
            "Feature work and support for Enterprise Content Management (C# ASP.NET, Aspose, PostgreSQL, TeamCity, Rider, BitBucket, Confluence, Jira)",
          ],
          link: "https://www.technologyone.com.au",
        },
        {
          name: "ITDSolutions",
          jobTitle: "Freelance Web Developer",
          employmentTime: "2019 to 2021",
          experience: [
            "Write modern, performant, maintainable code for a diverse array of client projects.",
            "Work with a variety of different languages, platforms and frameworks such as JavaScript, Vue, .Net, Digital Ocean.",
            "Met with clients to discuss project requiremnts.",
          ],
          link: "",
        },
        {
          name: "Wicet",
          jobTitle: "Web Developer",
          employmentTime: "2017 to 2018",
          experience: [
            "Researched and designed multiple user interfaces for critical internal applications.",
            "Communicated with multi-disciplinary teams of engineers, solution architects and project managers on a daily basis.",
            "Branding for public newsletters and internal project proposals.",
          ],
          link: "https://www.wicet.com.au/IRM/content/default.aspx",
        },
      ],
    };
  },
  methods: {
    goTo(ref) {
      // Prevent the default link behavior
      event.preventDefault();
      event.stopPropagation();

      var element = this.$refs[ref];
      var topOfElement = element.getBoundingClientRect().top;

      if (element) {
        // Scroll to the top of the element
        window.scrollTo({
          top: window.scrollY + topOfElement,
          behavior: "smooth", // You can also use 'auto' or 'instant'
        });
      }
    },
  },
  mounted() {
    this.emitter.on("element", (refName) => {
      this.goTo(refName);
    });
  },
};
</script>
